import SubscriptionProductModal from './SubscriptionProductModal';

export default {
  SubscriptionProductModal,
};
